// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./dev/stylist_parent/components/responsive-value-notice/index.scss
// module id = 951
// module chunks = 0